import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="px-6 md:px-12">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-14">
          <div className="lg:w-2/5">
            <span className="text-xs font-semibold tracking-widest uppercase text-foreground-500">
              Chi siamo
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3 leading-tight">
              Il punto di riferimento
              <br />
              italiano per
              <br />
              <span className="text-primary-500">Itaobuy Spreadsheet</span>
            </h2>
          </div>

          <div className="lg:w-3/5">
            <p className="text-foreground-700 leading-relaxed text-sm md:text-base">
              Questo progetto nasce con l&apos;obiettivo di creare una <strong>guida italiana completa</strong> dedicata a{' '}
              <strong>Itaobuy Spreadsheet</strong>. Il nostro team editoriale lavora costantemente per offrirti{' '}
              informazioni aggiornate, analisi approfondite delle categorie e consigli pratici per ottimizzare
              la tua esperienza di ricerca prodotti.
            </p>
            <p className="text-foreground-600 leading-relaxed text-sm md:text-base mt-4">
              Crediamo che una <strong>lista itaobuy</strong> ben organizzata possa fare la differenza
              nel processo di acquisto. Per questo motivo, mettiamo a disposizione guide dettagliate,
              confronti tra categorie e strategie per <strong>risparmiare tempo</strong> nella ricerca
              dei prodotti migliori. Ogni contenuto viene verificato dal nostro team per garantire
              <strong> accuratezza e affidabilit\u00e0</strong>.
            </p>
            <p className="text-foreground-600 leading-relaxed text-sm md:text-base mt-4">
              Dai un&apos;occhiata alla nostra{' '}
              <Link
                to="/articolo-itaobuy-spreadsheet-guida"
                className="text-primary-500 underline underline-offset-2 hover:text-primary-600 transition-colors font-medium cursor-pointer"
              >
                guida completa a Itaobuy Spreadsheet
              </Link>{' '}
              per approfondire ogni aspetto della piattaforma e scoprire tutti i{' '}
              <Link
                to="/"
                className="text-primary-500 underline underline-offset-2 hover:text-primary-600 transition-colors font-medium cursor-pointer"
              >
                consigli pratici
              </Link>{' '}
              che abbiamo preparato per te.
            </p>
          </div>
        </div>

        <div className="mt-10 md:mt-14 flex flex-col md:flex-row gap-4">
          <div className="md:w-2/5">
            <img
              src="https://readdy.ai/api/search-image?query=Minimalist%20editorial%20workspace%20with%20laptop%20showing%20organized%20data%2C%20notebook%20and%20ceramic%20coffee%20cup%20on%20light%20wood%20desk%2C%20warm%20natural%20light%20from%20window%2C%20terracotta%20and%20cream%20tones%2C%20clean%20sophisticated%20aesthetic%2C%20small%20potted%20olive%20plant&width=700&height=460&seq=about-left-v2-01&orientation=landscape&nocache=true"
              alt="Itaobuy Spreadsheet guide editoriale"
              className="w-full h-48 md:h-64 rounded-lg object-cover"
            />
          </div>
          <div className="md:w-3/5">
            <img
              src="https://readdy.ai/api/search-image?query=Curated%20collection%20of%20minimalist%20fashion%20accessories%20and%20clothing%20elegantly%20arranged%20on%20textured%20paper%20surface%2C%20soft%20warm%20ambient%20lighting%2C%20clean%20editorial%20style%2C%20sand%20olive%20and%20ivory%20tones%2C%20sophisticated%20European%20aesthetic%2C%20harmonious%20composition%20with%20ample%20negative%20space&width=900&height=460&seq=about-right-v2-01&orientation=landscape&nocache=true"
              alt="Itaobuy Spreadsheet prodotti"
              className="w-full h-48 md:h-64 rounded-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}